import cx from "classnames";
import { LoaderFunction, redirect, useLoaderData, useNavigate } from "react-router-dom";

import { useTranslation } from "@/core/i18n";
import { getPlatformCurrent, getReferralCodesByReferralCode } from "api/methods";
import { Button } from "atoms/button/Button";
import { RepeatMDFooter } from "atoms/repeatmd-footer/RepeatMDFooter";
import { queryClient } from "pages/Root";
import { waitObj } from "toolbox/Promise";

const load = async (referralCode: string) => {
  const platform = queryClient.fetchQuery({
    ...getPlatformCurrent.keyed(),
    queryFn: () => getPlatformCurrent().catch(() => null),
  });

  const code = queryClient.fetchQuery({
    ...getReferralCodesByReferralCode.keyed({ referralCode }),
  });

  return waitObj({
    platform,
    referralCode: code.then(({ code }) => code),
  });
};

type LoaderData = Awaited<ReturnType<typeof load>>;
export const friendReferralLandingLoader: LoaderFunction = async ({ params: { referralCode } }) => {
  if (!referralCode) {
    return redirect("/signin");
  }

  return load(referralCode);
};

export const FriendReferralLandingPage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { platform, referralCode } = useLoaderData() as LoaderData;
  const rewardsEnabled = platform?.platformSettings?.rewardsEnabled;

  return (
    <div>
      <div
        className={cx(
          "aspect-[390/350]",
          "flex-col",
          "bg-[url('assets/images/FriendReferralImage.png')]",
          "bg-cover",
          "bg-center",
        )}
      ></div>
      <div className="flex flex-col items-center justify-center gap-5 p-7 text-center">
        <img
          alt={t("friendReferralLandingPage.platformLogoAlt")}
          className="w-[40%] pb-3"
          src={platform?.logoImageUrl || ""}
        />
        <div className="px-5 text-h2 text-primary">{t("friendReferralLandingPage.title")}</div>
        <div className="text-body2 text-secondary">
          {rewardsEnabled
            ? t("friendReferralLandingPage.subtitleRewards")
            : t("friendReferralLandingPage.subtitleNoRewards")}
        </div>
        <Button fullWidth onClick={() => navigate(`/signin?referralCode=${referralCode}`)}>
          {rewardsEnabled
            ? t("friendReferralLandingPage.signUpToClaim")
            : t("friendReferralLandingPage.signUp")}
        </Button>
      </div>
      <div className="pt-3">
        <RepeatMDFooter showLinks />
      </div>
    </div>
  );
};
